<template>
    <input-base
    withLeftIcon
    :params="params"
    :rightButtonIcon="inputValue ? 'close' : ''"
    :inputFocused="inputFocused"
    :inputValue="inputValue"
    @rightButtonClicked="emit('input', '')"
    @click="preventInputClick ? emit('clicked') : null">
        <!-- Input slot -->
        <template v-slot:input>
            <!-- Search icon -->
            <search-icon/>
            <!-- Input -->
            <input
            v-if="preventInputClick"
            type="text"
            class="prevent-interation"
            :value="inputValue"
            :placeholder="params.placeholder || t('inputs.searchPlaceholder')">
            <!-- Input -->
            <input
            v-else
            type="text"
            ref="inputRef"
            :placeholder="params.placeholder || t('inputs.searchPlaceholder')"
            :value="inputValue"
			@keyup="checkIfReturnMobileClick"
            @focus="[emit('onFocus'), inputFocused = true]"
            @blur="[emit('onBlur'), inputFocused = false]"
            @keyup.enter="emit('onEnter')"
            @input="emit('input', $event.target.value)">
        </template>
    </input-base>
</template>

<script setup>
/* Components */
import InputBase from '@/components/generic/inputs/Base'
import SearchIcon from '@/assets/icons/search.svg?inline'

/* Vue Imports */
import { ref, onMounted } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
/* Emmitters */
const emit = defineEmits(['onFocus', 'onBlur', 'onEnter', 'input', 'clicked'])

/** props received
@params {
    - placeholder { String }
}
@preventInputClick {Boolean} prop to prevent input from being clicked or have text being placed on it
@inputValue {String, Number} value to be displayed in input
@focusInput {Boolean} - prop to trigger input focus
*/
const props = defineProps({
    params: Object,
    preventInputClick: Boolean,
    inputValue: [String, Number],
    focusInput: Boolean
})

const inputFocused = ref(false)
const inputRef = ref('')

const checkIfReturnMobileClick = $event => {
	if ($event.which === 13) document.activeElement.blur()
}

onMounted(() => {
    if (props.focusInput) inputRef.value.focus()
})
</script>

<style lang="scss" scoped>
input {
    width: 100%;
    height: 40px;

    @include H6-Regular;
    color: var(--secondary-dark-3);

    &.prevent-interation {
        pointer-events: none;
    }
}

svg {
    width: 16px;
    height: 16px;

    position: absolute;
    top: 12px;
    left: 16px;

    flex-shrink: 0;

    :deep(.change-color-fill) {
        stroke: var(--secondary);
        fill: var(--secondary);
    }
}

</style>
